import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'sg-ea-dialog',
  templateUrl: './ea-dialog.component.html',
  styleUrls: ['./ea-dialog.component.scss']
})
export class EaDialogComponent {

  @Output() EaDialogChange = new EventEmitter();

}
